import { JSX, useState } from "react";

interface ModalState {
  [key: string]: JSX.Element | null;
}

const useModals = () => {
  const [modals, setModals] = useState<ModalState>({});
  const [openModals, setOpenModals] = useState<{ [key: string]: boolean }>({});

  const openModal = (modalId: string, content: JSX.Element) => {
    setModals((prev) => ({ ...prev, [modalId]: content }));
    setOpenModals((prev) => ({ ...prev, [modalId]: true }));
  };

  const closeModal = (modalId: string) => {
    setModals((prev) => ({ ...prev, [modalId]: null }));
    setOpenModals((prev) => ({ ...prev, [modalId]: false }));
  };

  return { modals, openModals, openModal, closeModal };
};

export default useModals;

